export default __webpack_public_path__ + "static/media/688.2d87dbbe.png";